import type { AuthContextType } from '@context/auth.context';
import type { Conversation } from '@interfaces/conversation';
import { apiRequest, isResponse } from '@services/fetcher';
import type { LoaderFunction } from 'react-router-dom';

import { initConversations, useBoundStore } from '@/newstore';

export const loader = (auth: AuthContextType) =>
  (async ({ request, params }) => {
    const conversationId = Number(params.conversationId);
    if (Number.isNaN(conversationId)) {
      throw new Error('Invalid param specified.');
    }

    const conversationInitialized = useBoundStore.getState().conversations.byId?.[conversationId];
    if (!conversationInitialized) {
      const response = await apiRequest<Conversation>(
        `${import.meta.env.VITE_API_URL}/conversation/${conversationId}`,
        auth,
        {
          signal: request.signal,
        },
      );

      if (isResponse(response)) {
        return {
          status: response.status,
          statusText: response.statusText,
        } as Response;
      }

      if (response instanceof Error) {
        throw response;
      }

      initConversations([response]);
    }

    useBoundStore.getState().setActiveConversationId(conversationId);
    useBoundStore.getState().hideLeftColumn();
    useBoundStore.getState().openChatInfo();

    return useBoundStore.getState().conversations.byId?.[conversationId];
  }) satisfies LoaderFunction;
